<template>
  <div class="app-bar-container" v-if="isOpen && shouldAppBarOpen()">
    <input class="checkbox-cb" id="checkbox-cb" type="checkbox" />
    <div class="app-bar bg-beige">
      <div class="flex justify-between">
        <div class="flex">
          <div class="app-logo">
            <img src="/img/lg_sushi_white2.png" alt="" />
          </div>
          <div class="info">
            <p class="title">Sushi at Home App</p>
            <p>Faz download da nossa app</p>
          </div>
        </div>
        <div v-if="isApple()" class="download-icon">
          <img @click="goToAppStore('ios')" src="/svg/down-arrow.svg" alt="arrow" />
        </div>
        <div v-if="isAndroid()" class="download-icon">
          <img @click="goToAppStore('android')"  src="/svg/down-arrow.svg" alt="arrow" />
        </div>
        <label for="checkbox-cb" class="close-cb" @click="closeBanner()">
          x
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isOpen: true,
    };
  },
  methods: {
    isApple() {
      if (
        [
          "iPad Simulator",
          "iPhone Simulator",
          "iPod Simulator",
          "iPad",
          "iPhone",
          "iPod",
        ].includes(navigator.platform) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes("Mac") && "ontouchend" in document)
      ) {
        return true;
      } else {
        return false;
      }
    },
    isAndroid() {
      if (/(android)/i.test(navigator.userAgent)) {
        return true;
      } else {
        return false;
      }
    },
    goToAppStore(system){
      switch (system) {
        case 'ios':
          window.open('https://apps.apple.com/pt/app/sushi-at-home/id1226933767')
          this.closeBanner()
          break;
        case 'android':
          window.open('https://play.google.com/store/apps/details?id=pt.sushiathome')
          this.closeBanner()
          break;
        default:
          break;
      }
    },
    shouldAppBarOpen(){
      if(localStorage.getItem('closedAppbar') == 1){
        return false
      }
      if(this.isApple() || this.isAndroid()){
        return true
      }
      return false
    },
    closeBanner(){
      localStorage.setItem('closedAppbar', 1)
      this.isOpen = false
    }
  },
};
</script>